import { render, staticRenderFns } from "./BiblePresenceBadge.vue?vue&type=template&id=0e594bec&scoped=true"
import script from "./BiblePresenceBadge.vue?vue&type=script&lang=js"
export * from "./BiblePresenceBadge.vue?vue&type=script&lang=js"
import style0 from "./BiblePresenceBadge.vue?vue&type=style&index=0&id=0e594bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e594bec",
  null
  
)

export default component.exports